import { render, staticRenderFns } from "./Divider.vue?vue&type=template&id=71894136&scoped=true&"
import script from "./Divider.vue?vue&type=script&lang=js&"
export * from "./Divider.vue?vue&type=script&lang=js&"
import style0 from "./Divider.vue?vue&type=style&index=0&id=71894136&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71894136",
  null
  
)

export default component.exports